import type { SelectionDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { ManualSelectionItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";

import type { AppsExcelDownloadRequestDto, AppsExportRequestDto, AppsSearchRequestDto } from "../types/dto";

export const buildAppsExportData = (
    item: Readonly<SelectionDropdownItem>,
    selectedAppIds: readonly string[],
): AppsExportRequestDto => {
    if (item.id === ManualSelectionItem.ID) {
        return { apps: selectedAppIds };
    }

    return { count: item.value };
};

export const createAppsExcelExportRequestDto = (
    searchRequestDto: AppsSearchRequestDto,
    data: AppsExportRequestDto,
): AppsExcelDownloadRequestDto => {
    const { includeApps, top }: Pick<AppsExcelDownloadRequestDto, "includeApps" | "top"> =
        "count" in data ? { top: data.count } : { includeApps: data.apps };

    return {
        top,
        includeApps,
        queryFilters: searchRequestDto.queryFilters,
        orderBy: searchRequestDto.orderBy,
        asc: searchRequestDto.asc,
    };
};
